"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuListItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _Title = _interopRequireDefault(require("./Title"));
var _excluded = ["label", "style"];
function MenuListItem(props) {
  var label = props.label,
    style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    style: [style, styles.wrapper]
  }, rest), /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    style: [styles.label, style]
  }, label));
}
var styles = _reactNative.StyleSheet.create({
  wrapper: {
    height: 48 - 6,
    justifyContent: 'center'
  },
  label: {
    fontSize: 16,
    color: _styles.colors.feature,
    textAlign: 'center'
  }
});